import Page from "webPage/Page";
import {handleTestimonials} from "util/handleTestimonials";
import StyleGallery from "StyleGallery";

Page.register('tax-categories', () => {
    handleTestimonials();
    new StyleGallery($('.js-installation-gallery'));
});
